import React from 'react';

function ComingSoonFooter() {
  return (
    <div
      style={{
        display: 'flex',
        background: ' rgba(235, 235, 235, 0.8)',
        height: '35px',
        padding: '0 5vw',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        bottom: '0px',
        zIndex: 1,
      }}
    >
      <div style={{ fontSize: '12px', color: '#5a5a5a' }}>
        © 2026 SingleCombo • All rights reserved.
      </div>
    </div>
  );
}

export default ComingSoonFooter;
